// extracted by mini-css-extract-plugin
export var finaleWrapper = "finaleResults-module--finaleWrapper--1c-Fe";
export var sectionWhite = "finaleResults-module--sectionWhite--23Gvl";
export var title = "finaleResults-module--title--31bH1";
export var desc = "finaleResults-module--desc--2urAL";
export var finalimg = "finaleResults-module--finalimg--xL0bY";
export var textContainer = "finaleResults-module--textContainer--143xE";